
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Trash } from "lucide-react";

export const TrashCleanliness = () => {
  return (
    <RegulationItem 
      value="trash-cleanliness" 
      icon={Trash}
      iconColor="text-green-600"
      title="Trash & Cleanliness"
    >
      <ul className="space-y-2 text-tribal-neutral list-disc pl-5">
        <li>Maintain the beauty of Duck Valley; dispose of trash responsibly.</li>
        <li>No littering allowed.</li>
        <li>Do not dispose of fish remains in dumpsters.</li>
        <li>Restroom facilities are provided for your convenience; please help us keep them clean.</li>
      </ul>
    </RegulationItem>
  );
};
